import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiAward,FiUsers,FiTrendingUp,FiArrowRight}=FiIcons;

const About=()=> {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{opacity: 0,x: -30}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Über RUDT Bau
              </h2>
              <div className="w-20 h-1 bg-[#3466ad] mb-8"></div>
            </div>

            <div className="space-y-6">
              <p className="text-lg text-gray-600 leading-relaxed">
                Seit 2022 steht RUDT Bau für erstklassige Bauarbeiten in der Region. Mit über 20 Jahren Berufserfahrung im Baugewerbe vereinen wir traditionelles Handwerk mit modernsten Techniken und Materialien.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Unser erfahrenes Team realisiert Projekte aller Größenordnungen - vom Einfamilienhaus bis zum Gewerbebau. Dabei stehen Qualität, Zuverlässigkeit und Kundenzufriedenheit immer im Mittelpunkt.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-[#3466ad] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <SafeIcon icon={FiAward} className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Qualität</h3>
                <p className="text-sm text-gray-600">Höchste Standards</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 bg-[#3466ad] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <SafeIcon icon={FiUsers} className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">Erfahrenes Team</h3>
                <p className="text-sm text-gray-600">4 Fachkräfte</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 bg-[#3466ad] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <SafeIcon icon={FiTrendingUp} className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-1">20+ Jahre</h3>
                <p className="text-sm text-gray-600">Berufserfahrung</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/ueber-uns"
                className="inline-flex items-center space-x-2 bg-[#3466ad] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#2a5291] transition-colors duration-200"
              >
                <span>Mehr über uns</span>
                <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center space-x-2 border-2 border-[#3466ad] text-[#3466ad] px-6 py-3 rounded-lg font-medium hover:bg-[#3466ad] hover:text-white transition-colors duration-200"
              >
                <span>Projekt besprechen</span>
              </Link>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{opacity: 0,x: 30}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8,delay: 0.2}}
            className="relative"
          >
            <div className="aspect-square bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://canv.wasacon.com/rudt-bau/_assets/media/45e5af10c8d00190ecd5c35d2c5c7c03.jpg"
                alt="RUDT Bau Team bei der Arbeit"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Overlay Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border border-gray-200">
              <div className="text-center">
                <div style={{color: 'rgb(52,102,173)'}} className="text-3xl font-bold text-[#3466ad] mb-1">40+</div>
                <div className="text-sm text-gray-600">Projekte realisiert</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;